export const search = {
    search: "검색",
    close: "닫기",
    reset: "초기화",
    submit: "검색",
    level: "학년",
    department: "학과",
    term: "기간",
    time: "시간",
    all: "전체",
    type: "분류",
    placeholder: "과목명, 교수명을 등을 검색해보세요",
    empty: "검색 조건을 하나 이상 선택해주세요",
    departmentUnavailable:
        "선택한 학과를 검색할 수 없습니다. 잠시 후 다시 시도해 주세요.",
    timeFilterPlaceholder: "시간표에서 드래그하여 선택",
}
